export default __webpack_public_path__ + "static/media/bannerimg.d08e7ddb.png";